export default "__VITE_ASSET__CP2ny0fr__$_?component__"